import useMeetingsRefresh from "../../hooks/useMeetingsRefresh";
import RefreshMeetingsButton from "./RefreshMeetingsButton";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import TherapyRoomCard from "./TherapyRoomCard";
import Navbar from "../Navbar";
import Footer from "../Footer";
import TherapistSidebar from "../TherapistSidebar";
import TherapistClients from "../TherapistClients";
import ClientChatHistory from "../ClientChatHistory";
import beach from "../../assets/images/beach.png";
import forest from "../../assets/images/forest.png";
import campsite from "../../assets/images/campsite.png";
import winterHoliday from "../../assets/images/winterHoliday.png"
import park from "../../assets/images/park.png";
import summerSun from "../../assets/images/sun.png";
import summerCloudSet1 from "../../assets/images/clouds.png";
import summerCloudSet2 from "../../assets/images/clouds2.png";
import summerBirdSet1 from "../../assets/images/birds.png";
import summerBirdSet2 from "../../assets/images/birds.png";
import summerWaves from "../../assets/images/waves.png";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import axiosInstance from "../../api/axiosInstance";
import { AuthContext } from "../../context/AuthContext";
import Env from "../../runtimeEnv";
import HelpCenter from "../HelpCenter/HelpCenter";
import HelpCenterDetail from "../HelpCenter/HelpCenterDetail";
import learningContent from "../HelpCenter/learningContent.json";
import TherapistHome from "./TherapistHome"
import sessionIcon from "../../assets/images/session.svg";
import clientIcon from "../../assets/images/client.svg";
import helpIcon from "../../assets/images/help.svg";
import shieldIcon from "../../assets/images/shield.svg";
import learningCenterHero from "../../assets/images/learning-center-hero.png";

function TherapistTherapyRooms() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [enabledRoom, setEnabledRoom] = useState([]);
  const [loading, setLoading] = useState(true);
  const [roomsOnlineStatus, setRoomsOnlineStatus] = useState({});
  const [sessionStartTimes, setSessionStartTimes] = useState({});
  const [selectedSpace, setSelectedSpace] = useState(null);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [activeNavItem, setActiveNavItem] = useState("home");
  const [selectedClient, setSelectedClient] = useState(null);
  const [clientsData, setClientsData] = useState(null);
  const [clientsDataLoading, setClientsDataLoading] = useState(false);
  const [hasFetchedData, setHasFetchedData] = useState(false);
  const {
    currentNickname,
    setCurrentNickname,
    PlutonicuserID,
    userType,
    selectedTherapyType,
    isAdmin
  } = useContext(AuthContext);

  const [selectedHelpSection, setSelectedHelpSection] = useState(null);
  const [helpSections, setHelpSections] = useState([]);
  const [loadingHelp, setLoadingHelp] = useState(true);
  const helpArticles = helpSections.filter((section) => section.category === "help");
  const policyArticles = helpSections.filter((section) => section.category === "policies");
  const [selectedPolicySection, setSelectedPolicySection] = useState(null);
  const [learningSections, setLearningSections] = useState(learningContent);
  const [loadingLearning, setLoadingLearning] = useState(false);
  const [selectedLearningSection, setSelectedLearningSection] = useState(null);
  const learningArticles = learningSections.filter(
    (section) =>
      section.category === "learning" &&
      section.showInLearningCenter !== false
  );
  const [homeChecklist, setHomeChecklist] = useState([]);


useEffect(() => {
  const fetchChecklist = async () => {
    try {
      const res = await fetch(
        "https://react-resources.s3.us-east-1.amazonaws.com/homeChecklist.json?v=" + Date.now()
      );

      const data = await res.json();
      setHomeChecklist(data);
    } catch (err) {
      console.error(err);
    }
  };

  fetchChecklist();
}, []);

useEffect(() => {
  const fetchHelp = async () => {
    try {
      const res = await fetch(
        "https://react-resources.s3.us-east-1.amazonaws.com/helpContent.json?v=" + Date.now()
      );

      if (!res.ok) throw new Error("Failed to fetch");

      const data = await res.json();
      setHelpSections(data);
    } catch (err) {
      console.error("Help content failed:", err);
      setHelpSections([]);
    } finally {
      setLoadingHelp(false);
    }
  };

  fetchHelp();
}, []);

useEffect(() => {
  const stateTab = location.state?.tab;

  if (location.pathname.startsWith("/clients")) {
    setActiveNavItem("clients");
    return;
  }

  if (location.pathname === "/") {
  setActiveNavItem(stateTab ?? "home");
  return;
}
}, [location.pathname, location.state]);

useEffect(() => {
  if (activeNavItem !== "learning") return;

  const fetchLearning = async () => {
    setLoadingLearning(true);

    try {
      const res = await fetch(
        "https://react-resources.s3.us-east-1.amazonaws.com/learningContent.json?v=" + Date.now()
      );

      if (!res.ok) throw new Error("Failed to fetch");

      const data = await res.json();
      setLearningSections(data);
    } catch (err) {
      console.error("Learning content failed:", err);
      setLearningSections(learningContent);
    } finally {
      setLoadingLearning(false);
    }
  };

  fetchLearning();
}, [activeNavItem]);

  useEffect(() => {
    if (params.sessionID && activeNavItem === "clients") {
      if (clientsData) {
        const targetSession = findSessionInClientsData(
          clientsData,
          params.sessionID
        );
        if (targetSession) {
          setSelectedClient(targetSession);
        } else {
          fetchClientsData(true).then((freshData) => {
            if (freshData) {
              const freshSession = findSessionInClientsData(
                freshData,
                params.sessionID
              );
              if (freshSession) {
                setSelectedClient(freshSession);
              }
            }
          });
        }
      } else {
        fetchClientsData().then((data) => {
          if (data) {
            const foundSession = findSessionInClientsData(
              data,
              params.sessionID
            );
            if (foundSession) {
              setSelectedClient(foundSession);
            }
          }
        });
      }
    } else if (!location.pathname.startsWith("/clients/")) {
      setSelectedClient(null);
    }
  }, [params.sessionID, activeNavItem, location.pathname]);

  useEffect(() => {
    const updateSidebarForScreen = () => {
      if (typeof window !== "undefined") {
        setSidebarCollapsed(window.innerWidth < 1024);
      }
    };
    updateSidebarForScreen();
    window.addEventListener("resize", updateSidebarForScreen);
    return () => window.removeEventListener("resize", updateSidebarForScreen);
  }, []);

  const { refreshMeetings, refreshing, refreshError } = useMeetingsRefresh(async (signal) => {
      const savedUserID =
        PlutonicuserID || localStorage.getItem("PlutonicuserID");
      const savedNickname =
        currentNickname || localStorage.getItem("currentNickname");

      if (savedNickname) {
        setCurrentNickname(savedNickname);
      }

      if (savedUserID) {
        try {
          const response = await axios.get(
            `${Env.REACT_APP_PYTHON_API_URL}/api/GetMeetings/${savedUserID}`,
            {
              signal,
              headers: {
                "Cache-Control": "no-cache",
                Pragma: "no-cache",
                Expires: "0",
              },
              params: { t: new Date().getTime() },
            }
          );

          if (signal.aborted) return;
          if (response.data.length > 0) {
            const nowUTC = new Date();

            const gracePeriodBeforeMs = 15 * 60 * 1000;
            const gracePeriodAfterMs = 75 * 60 * 1000;
            const backToBackBufferMs = 20 * 60 * 1000;

            let latestUpcomingSession = null;

            const roomSessionsMap = response.data.reduce((acc, room) => {
              const roomId = room.meetingID.split(".")[0].replace("-therapy", "");
              const sessionTimeUTC = new Date(room.sessionTime);

              const formattedTimeEST =
                sessionTimeUTC.toLocaleString("en-US", {
                  timeZone: "America/New_York",
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                }) + " EST";

              if (!acc[roomId]) acc[roomId] = [];

              acc[roomId].push({
                meetingID: room.meetingID,
                sessionStartTimeEST: formattedTimeEST,
                sessionStartTimeUTC: sessionTimeUTC.toISOString(),
                rawStartTime: sessionTimeUTC,
                online: room.online.some((s) => s === true),
                selectedSpace: room.selectedSpace || "",
                isAvailable: false,
                isUpcoming: false,
              });

              return acc;
            }, {});

            Object.keys(roomSessionsMap).forEach((roomId) => {
              const sessions = roomSessionsMap[roomId];

              sessions.sort((a, b) => {
                if (a.isPrimary && !b.isPrimary) return -1;
                if (!a.isPrimary && b.isPrimary) return 1;
                return (
                  new Date(a.sessionStartTimeUTC) -
                  new Date(b.sessionStartTimeUTC)
                );
              });

              for (let i = 0; i < sessions.length; i++) {
                const current = sessions[i];
                const next = sessions[i + 1];

                const currentStart = new Date(current.sessionStartTimeUTC);
                const timeUntilCurrent = currentStart - nowUTC;
                const timeSinceCurrent = nowUTC - currentStart;

                const isInGraceWindow =
                  (timeUntilCurrent <= gracePeriodBeforeMs &&
                    timeUntilCurrent >= 0) ||
                  (timeSinceCurrent >= 0 &&
                    timeSinceCurrent <= gracePeriodAfterMs);

                const isUpcoming =
                  timeUntilCurrent > 0 &&
                  timeUntilCurrent <= gracePeriodBeforeMs;

                let isSuppressed = false;

                if (next) {
                  const nextStart = new Date(next.sessionStartTimeUTC);
                  const timeUntilNext = nextStart - nowUTC;

                  const allowSuppression =
                    timeUntilNext <= backToBackBufferMs &&
                    timeUntilNext >= -15 * 60 * 1000;

                  if (allowSuppression) {
                    isSuppressed = true;
                    next.isUpcoming = true; 
                  }
                }

                current.isAvailable = isInGraceWindow;
                current.isUpcoming = isUpcoming;
                current.isPrimary =
                  (isInGraceWindow || isUpcoming) && !isSuppressed;

                if (
                  current.isPrimary &&
                  current.selectedSpace?.trim() !== "" &&
                  (!latestUpcomingSession ||
                    currentStart >
                      new Date(latestUpcomingSession.sessionStartTimeUTC))
                ) {
                  latestUpcomingSession = current;
                }
              }
            });

            const sessionStartTimesMap = Object.entries(roomSessionsMap).reduce(
              (acc, [roomId, sessions]) => {
                const nextSession = sessions.find(
                  (s) => s.isAvailable || s.isUpcoming
                );
                if (nextSession) acc[roomId] = nextSession.sessionStartTimeEST;
                return acc;
              },
              {}
            );

            const onlineStatusMap = Object.entries(roomSessionsMap).reduce(
              (acc, [roomId, sessions]) => {
                acc[roomId] = sessions.some((s) => s.online);
                return acc;
              },
              {}
            );

            if (latestUpcomingSession) {
              setSelectedSpace(latestUpcomingSession.selectedSpace || null);
            } else {
              setSelectedSpace(null);
            }

            setRoomsOnlineStatus(onlineStatusMap);
            setEnabledRoom(roomSessionsMap);
            setSessionStartTimes(sessionStartTimesMap);
          } else {
            setEnabledRoom({});
            setRoomsOnlineStatus({});
            setSessionStartTimes({});
            setSelectedSpace(null);
          }
        } catch (error) {
          if (!signal.aborted) setLoading(false);
          throw error;
        }
      }

      if (!signal.aborted) setLoading(false);
  }, PlutonicuserID);

  const normalRooms = [
    {
      id: "campsite",
      title: "Plutonic Therapy Campfire",
      description:
        "Unpack your thoughts with your licensed mental health professional next to the campfire. Trees swaying and crickets chirping while enjoying the beautiful night sky. ",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Green Space",
      usage: "Family Counseling",
      image: campsite,
      available:
        enabledRoom["campsite"]?.some((session) => session.isAvailable) ||
        false,
      selectable: enabledRoom["campsite"]?.length > 0 ?? false, // Selectable if a meeting exists
      // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: false,
      online: roomsOnlineStatus["campsite"] || false,
      sessionStartTimeEST: sessionStartTimes["campsite"] || "",
    },
    {
      id: "mountain",
      title: "Plutonic Therapy Forest Office",
      description:
        "Consider having a session with your licensed mental health professional next to the fireplace. Take in the sounds and sights of the forest.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Modern Design",
      usage: "Family Counseling",
      image: forest,
      // available: enabledRoom["mountain"]?.some((session) => session.isAvailable) || false,
      // selectable: false, // Cannot select "coming soon" rooms
      available:
        enabledRoom["mountain"]?.some((session) => session.isAvailable) ||
        false,
      selectable: enabledRoom["mountain"]?.length > 0 ?? false, // Selectable if a meeting exists
      isComingSoon: false,
      online: roomsOnlineStatus["mountain"] || false,
      sessionStartTimeEST: sessionStartTimes["mountain"] || "",
    },
    {
      id: "beach",
      title: "Plutonic Therapy Beach Office",
      description:
        "Consider having a session with your licensed mental health professional inside the office or in the cabana. Take in the sounds of the ocean waves and the sunset as you reduce stress.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Modern Design",
      usage: "Family Counseling",
      image: beach,
      // available: enabledRoom["beach"]?.some((session) => session.isAvailable) || false,
      selectable: enabledRoom["beach"]?.length > 0 ?? false, // Selectable if a meeting exists
      available:
        enabledRoom["beach"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: false,
      online: roomsOnlineStatus["beach"] || false,
      sessionStartTimeEST: sessionStartTimes["beach"] || "",
    },
    {
      id: "park",
      title: "Plutonic Therapy Quiet Park",
      description:
        "Consider having a session with your licensed mental health professional while taking a walk around the park or while sitting on a park bench. This quiet park is a perfect safe space to talk.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Green Space",
      usage: "Family Counseling",
      image: park,
      available:
        enabledRoom["park"]?.some((session) => session.isAvailable) || false,
      selectable: enabledRoom["park"]?.length > 0 ?? false, // Selectable if a meeting exists
      // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: false,
      online: roomsOnlineStatus["park"] || false,
      sessionStartTimeEST: sessionStartTimes["park"] || "",
    },
    {
                  id: "winter-holiday",
                  title: "Plutonic Therapy Winter Cabin",
                  description:
                    "Step into a cozy winter lodge where soft snow falls outside and warm lantern lights fills the cabin. Settle into the gentle winter ambience.",
                  accessibility: "PC Web Browser | Chrome, Edge",
                  style: "Seasonal",
                  usage: "Seasonal",
                  image: winterHoliday,
                  available:
                    enabledRoom["winter-holiday"]?.some((session) => session.isAvailable) ||
                    false,
                  selectable: enabledRoom["winter-holiday"]?.length > 0 ?? false, // Selectable if a meeting exists
                  // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
                  isComingSoon: false,
                  online: roomsOnlineStatus["winter-holiday"] || false,
                  sessionStartTimeEST: sessionStartTimes["winter-holiday"] || "",
                },
  ];

  // TODO: We can remove this if a therapist is not using AI
  const aiRooms = [
    {
      id: "beach-ai-companion",
      title: "Plutonic Beach Office",
      description:
        "Talk to your mental health companion inside the office or in the cabana. Take in the sounds of the ocean waves and the sunset.",
      accessibility: "PC Web Browser | Chrome, Edge, Firefox",
      style: "Modern Design",
      usage: "Family Counseling",
      image: beach,
      selectable: true,
      available: true,
      isComingSoon: false,
      online: true,
      sessionStartTimeEST: "Always Available",
    },
    // {
    //   id: "mountain-ai-companion",
    //   title: "Plutonic Therapy Forest Office",
    //   description:
    //     "Consider having a session with your licensed mental health professional next to the fireplace. Take in the sounds and sights of the forest.",
    //   accessibility: "PC Web Browser | Chrome, Edge",
    //   style: "Modern Design",
    //   usage: "Family Counseling",
    //   image: forest,
    //   available: false,
    //   selectable: false,
    //   isComingSoon: true,
    //   online: false,
    //   sessionStartTimeEST: "Unavailable",
    // },

    // {
    //   id: "park-ai-companion",
    //   title: "Plutonic Therapy Quiet Park",
    //   description:
    //     "Consider having a session with your licensed mental health professional while taking a walk around the park or while sitting on a park bench. This quiet park is a perfect safe space to talk.",
    //   accessibility: "PC Web Browser | Chrome, Edge",
    //   style: "Green Space",
    //   usage: "Family Counseling",
    //   image: park,
    //   available: false,
    //   selectable: false,
    //   isComingSoon: true,
    //   online: false,
    //   sessionStartTimeEST: "Unavailable",
    // },
    {
      id: "campsite-ai-companion",
      title: "Plutonic Campfire",
      description:
        "Unpack your thoughts with your mental health companion next to the campfire. Trees swaying and crickets chirping while enjoying the beautiful night sky.",
      accessibility: "PC Web Browser | Chrome, Edge, Firefox",
      style: "Green Space",
      usage: "Family Counseling",
      image: campsite,
      available: false,
      selectable: false,
      isComingSoon: true,
      online: false,
      sessionStartTimeEST: "Unavailable",
    },
  ];

  const selectedRooms = selectedTherapyType === "ai" ? aiRooms : normalRooms;

  const fetchClientsData = async (forceRefresh = false) => {
    if (!forceRefresh && clientsData) {
      return clientsData;
    }

    if (!forceRefresh && (clientsDataLoading || hasFetchedData)) {
      return clientsData;
    }

    try {
      setClientsDataLoading(true);
      if (forceRefresh) {
        setHasFetchedData(false);
      }
      const response = await axiosInstance.get("/api/summarize");

      if (response.data) {
        setClientsData(response.data);
        setHasFetchedData(true);
        return response.data;
      }
    } catch (error) {
      console.error("Error fetching clients data:", error);
    } finally {
      setClientsDataLoading(false);
    }
    return null;
  };

  const findSessionInClientsData = (data, sessionID) => {
    if (!data || !data.clients) return null;

    for (const client of data.clients) {
      if (client.sessions) {
        const session = client.sessions.find((s) => s.sessionID === sessionID);
        if (session) {
          return {
            ...client,
            sessions: [session],
            selectedSessionID: sessionID,
          };
        }
      }
    }
    return null;
  };

  const handleViewClientHistory = (client) => {
    setSelectedClient(client);
  };

  const handleBackToClients = () => {
    setSelectedClient(null);
    navigate("/clients");
  };

  const handleEnterClick = (roomType, meetingID = "") => {
    if (roomType.startsWith("test-")) {
      const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");
      const testMeetingID = `${roomType}-test-meeting-id`;
      sessionStorage.setItem("meetingID", testMeetingID);
      sessionStorage.setItem("userId", userId);

      const realRoomType = roomType.replace("test-", ""); 
      navigate(`/unity-room/${realRoomType}`);
      return;
    }

    const roomSessions = enabledRoom[roomType];
    if (!roomSessions || roomSessions.length === 0) {
      alert("Room is not enabled. Please wait or check your eligibility.");
      return;
    }

    if (roomType.includes("-ai-")) {
      const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");
      const aiMeetingID = `${roomType}-meeting-${userId}`;
      sessionStorage.setItem("meetingID", aiMeetingID);
      sessionStorage.setItem("userId", userId);
      navigate(`/unity-room/${roomType}`);
      return;
    }

    const session = roomSessions.find((s) => s.meetingID === meetingID);
    if (!session) {
      alert("Selected session is not available.");
      return;
    }

    const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");
    sessionStorage.setItem("meetingID", session.meetingID);
    sessionStorage.setItem("userId", userId);
    navigate(`/unity-room/${roomType}`);
  };

  // if (loading) {
  //   return (
  //     <div
  //       style={{
  //         height: "100vh",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //       }}
  //     >
  //       <p>Loading...</p>
  //     </div>
  //   );
  // }

  return (
  <div>
    <Navbar />

    {userType === "Therapist" && (
      <TherapistSidebar
        activeNavItem={activeNavItem}
        setActiveNavItem={setActiveNavItem}
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
        learningSubsections={learningSections.filter((section) =>
          [
            "learning-children-preteens-examples",
            "learning-adolescents-examples",
          ].includes(section.id)
        )}
        selectedLearningSectionId={selectedLearningSection?.id}
        onSelectLearningSection={(section) => {
          setSelectedLearningSection(section);
          setActiveNavItem("learning");
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      />
    )}

       {activeNavItem === "home" ? (
  <div
  className={`min-h-screen pt-24 pb-16 transition-all duration-300 ${
    sidebarCollapsed ? "ml-16" : "ml-64"
  }`}
>
    <TherapistHome
  therapistName={currentNickname}
  therapistId={PlutonicuserID || localStorage.getItem("PlutonicuserID")}
  checklistData={homeChecklist}
  onInternalLink={(link) => {
    if (link.type === "help") {
      const section = helpSections.find((s) => s.id === link.id);

      if (section) {
        setSelectedHelpSection(section);
        setActiveNavItem("help");
        window.scrollTo({
  top: 0,
  behavior: "smooth"
});
      }
    }

    if (link.type === "policies") {
      const section = helpSections.find((s) => s.id === link.id);

      if (section) {
        setSelectedPolicySection(section);
        setActiveNavItem("policies");
        window.scrollTo({
  top: 0,
  behavior: "smooth"
});
      }
    }

    if (link.type === "learning") {
      const section = learningSections.find((s) => s.id === link.id);

      if (section) {
        setSelectedLearningSection(section);
        setActiveNavItem("learning");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  }}
  quickActions={[
  {
    id: "sessions",
    name: "Sessions",
    icon: sessionIcon,
    onClick: () => navigate("/", { state: { tab: "sessions" } }),
  },
  {
    id: "clients",
    name: "Clients",
    icon: clientIcon,
    onClick: () => navigate("/clients"),
  },
  {
    id: "help",
    name: "Help Center",
    icon: helpIcon,
    onClick: () => navigate("/", { state: { tab: "help" } }),
  },
  {
    id: "learning",
    name: "Learning Center",
    icon: helpIcon,
    onClick: () => navigate("/", { state: { tab: "learning" } }),
  },
  {
    id: "policies",
    name: "Policies",
    icon: shieldIcon,
    onClick: () => navigate("/", { state: { tab: "policies" } }),
  },
]}
/>
  </div>
) :

    activeNavItem === "sessions" ? (
      <div
        className={`relative min-h-screen pt-24 pb-16 transition-all duration-300 ${
          sidebarCollapsed ? "ml-16" : "ml-64"
        }`}
        style={{
  background:
    "linear-gradient(to bottom, #61D8FF, #D7FFF6, #FFF9B8)",
}}
      >
        <div
  className="absolute inset-0 z-0 pointer-events-none overflow-hidden"
  style={{ isolation: "isolate" }}
>
  {/* ☀️ Sun */}
  <img
    src={summerSun}
    alt="sun"
    className="absolute top-[13vh] right-[1vw] w-[225px] md:w-[225px] pointer-events-none select-none z-0 animate-[spin_120s_linear_infinite]"
  />

  {/* ☁️ Clouds */}
  <img
    src={summerCloudSet1}
    alt="clouds top left"
    className="absolute top-[12vh] left-[8vw] w-[280px] md:w-[360px] pointer-events-none select-none z-0"
  />

  <img
    src={summerCloudSet2}
    alt="clouds middle"
    className="absolute top-[10vh] left-[44%] w-[300px] md:w-[380px] pointer-events-none select-none z-0"
  />

  {/* 🕊 Birds */}
  <img
    src={summerBirdSet1}
    alt="birds left"
    className="absolute top-[38vh] left-[10vw] w-[140px] md:w-[180px] opacity-85 pointer-events-none select-none z-0"
  />

  <img
    src={summerBirdSet2}
    alt="birds right"
    className="absolute top-[21vh] right-[17vw] w-[150px] md:w-[190px] opacity-85 pointer-events-none select-none z-0"
  />

  {/* 🌊 Waves */}
  <img
    src={summerWaves}
    alt="waves footer"
    className="absolute bottom-0 left-0 w-full h-[28vh] md:h-[32vh] object-cover pointer-events-none select-none z-0"
  />
</div>
        <div className="relative z-10 w-full max-w-7xl mx-auto px-12">
          <h2 className="text-3xl font-bold mb-12 pl-4 mt-8">
            Your Virtual Spaces
            <RefreshMeetingsButton onRefresh={refreshMeetings} refreshing={refreshing} />
          </h2>
          {refreshError && <p role="alert" className="text-red-600">{refreshError}</p>}

          <div className="grid gap-8 grid-cols-1 md:grid-cols-2 w-full">
            {selectedRooms.map((room) => (
              <TherapyRoomCard
                key={room.id}
                room={room}
                isSelected={selectedSpace === room.id}
                onEnterClick={(meetingID) =>
                  handleEnterClick(room.id, meetingID)
                }
                sessions={enabledRoom[room.id] || []}
              />
            ))}
          </div>
        </div>
      </div>

    ) : activeNavItem === "help" ? (
      <div
        className={`min-h-screen pt-24 pb-16 transition-all duration-300 bg-white ${
          sidebarCollapsed ? "ml-16" : "ml-64"
        }`}
      >
        {loadingHelp ? (
  <div className="min-h-screen flex items-center justify-center">
  Loading...
</div>
) : selectedHelpSection ? (
  <HelpCenterDetail
    section={selectedHelpSection}
    onBack={() => setSelectedHelpSection(null)}
  />
) : (
  <HelpCenter
    title="Help Center"
    sections={helpArticles}
    onSelectSection={setSelectedHelpSection}
  />
)}
      </div>

    ) : activeNavItem === "learning" ? (
      <div
        className={`min-h-screen pb-16 pt-[83px] transition-all duration-300 bg-white ${
          sidebarCollapsed ? "ml-16" : "ml-64"
        }`}
      >
        {loadingLearning ? (
          <div className="min-h-screen flex items-center justify-center">
            Loading...
          </div>
        ) : selectedLearningSection ? (
          <HelpCenterDetail
            section={
              learningSections.find(
                (section) => section.id === selectedLearningSection.id
              ) || selectedLearningSection
            }
            onBack={() => setSelectedLearningSection(null)}
          />
        ) : (
          <HelpCenter
            title="Plutonic Learning Center"
            description="Learn practical, evidence-informed strategies for using Plutonic Virtual Therapy across different age groups and clinical presentations. Content focuses on applying platform features to strengthen engagement, therapeutic alliance, and evidence-based interventions."
            heroImage={learningCenterHero}
            heroImageAlt="Virtual therapy and clinician learning illustration"
            disclaimer="Plutonic Virtual Therapy is a therapeutic platform that provides optional virtual environments and interactive features to support psychotherapy. The content within this Learning Center is intended for educational purposes only and does not constitute medical advice, clinical supervision, or a standard of care. References to specific diagnoses or clinical presentations are illustrative of potential applications and are not intended to represent indications for treatment, guarantees of effectiveness, or recommendations that the platform be used with any particular client population. Treating clinicians remain solely responsible for all clinical decisions, treatment planning, risk assessment, and the delivery of care."
            variant="training"
            sections={learningArticles}
            onSelectSection={setSelectedLearningSection}
          />
        )}
      </div>

    ) : activeNavItem === "policies" ? (
      <div
        className={`min-h-screen pt-24 pb-16 transition-all duration-300 bg-white ${
          sidebarCollapsed ? "ml-16" : "ml-64"
        }`}
      >
        {loadingHelp ? (
  <div className="min-h-screen flex items-center justify-center">
  Loading...
</div>
) : selectedPolicySection ? (
  <HelpCenterDetail
    section={selectedPolicySection}
    onBack={() => setSelectedPolicySection(null)}
  />
) : (
  <HelpCenter
    title="Policies"
    sections={policyArticles}
    onSelectSection={setSelectedPolicySection}
  />
)}
      </div>

    ) : activeNavItem === "clients" ? (
      selectedClient ? (
        <div
          className={`transition-all duration-300 ${
            sidebarCollapsed ? "ml-16" : "ml-64"
          }`}
        >
          <ClientChatHistory
            client={selectedClient}
            onBack={handleBackToClients}
          />
        </div>
      ) : (
        <div
          className={`min-h-screen pt-24 pb-16 transition-all duration-300 bg-white ${
            sidebarCollapsed ? "ml-16" : "ml-64"
          }`}
        >
          <div className="w-full mx-auto px-12">
            <TherapistClients
              onViewHistory={handleViewClientHistory}
              clientsData={clientsData}
              fetchClientsData={fetchClientsData}
              loading={clientsDataLoading}
              isAdmin={isAdmin}
            />
          </div>
        </div>
      )
    ) : null}

    <Footer />
  </div>
);
}

export default TherapistTherapyRooms;
